export const cmcTheme = {
  globals: {
    name: 'myPos',
    fontFamily: 'Inter',
    fontFamilyHeadline: 'Inter',
    fontFamilyBold: 'Inter',
    bgColor: '#FFFFFF',
    linkColor: 'rgba(50, 95, 255, 1)',
    linkColorHover: 'rgba(91, 127, 255, 1)',
    checkboxColor: 'rgba(50, 95, 255, 1)',
    checkboxColorActive: 'rgba(50, 95, 255, 1)',
    checkboxBorderRadius: '4px',
    inputRequired: {
      asteriskColor: 'rgba(50, 95, 255, 1)',
      textColor: 'rgba(50, 95, 255, 1)',
      textFontSize: '14px',
    },
  },
  contentWrap: {},
  container: {
    bgColor: '#FFFFFF',
    width: '100%',
    padding: '50px',
    borderRadius: '8px',
    border: '1px solid rgba(230, 221, 249, 1)',
    boxShadow: '2px 2px 10px 0px rgba(0, 0, 0, 0.07)',
    margin: '0 auto',
    color: 'rgba(52, 53, 58, 1)',
  },
  documentCheckbox: {
    iconColor: 'rgba(52, 53, 58, 1)',
    iconHover: 'rgba(0, 0, 0, 1)',
    width: '100%',
    contentFontSize: '14px',
    margin: '20px',
  },
  icon: {
    docVerifyDotsColor: 'rgba(255, 255, 255, 1)',
    mainIconColor: 'rgba(50, 95, 255, 1)',
    colorHover: 'rgba(50, 95, 255, 1) ',
    backgroundColor: 'rgba(247, 249, 252, 1)',
    size: '32px',
    thickness: '0.2px',
  },
  otpInput: {
    width: '100%',
    columnGap: '10px',
    marginTop: '10px',
    marginBottom: '30px',
    inputHeight: '60px',
    inputBorder: '2px solid rgba(206, 212, 220, 1)',
    borderRadius: '2px',
    fontSize: '22px ',
    focusColor: 'rgba(50, 95, 255, 1)',
    bgColor: 'rgba(255, 255, 255, 1)',
    focusBgColor: 'rgba(255, 255, 255, 1)',
    fontColor: 'rgba(0, 0, 0, 1)',
    loadingColor: 'rgba(50, 95, 255, 1)',
  },
  pdfViewer: {
    pageBackground: '#FFFFFF',
    containerBorder: '2px solid rgba(206, 212, 220, 1)',
    scrollTrackColor: '#CED4DC',
    scrollHandleColor: 'rgba(50, 95, 255, 1)',
    scrollRadius: '0px',
    toolbox: {
      color: '#FFFFFF',
      bgColor: 'rgba(0, 0, 0, 0.70)',
      borderRadius: '4px',
      padding: '5px',
      boxShadow: '#none',
    },
    zoomButton: {
      bgColor: '#FFFFFF',
      color: '#34353A',
      border: '2px solid rgba(50, 95, 255, 1)',
      bgColorHover: '#F1F3F7',
      colorHover: '#34353A',
      borderHover: '2px solid rgba(50, 95, 255, 1)',
    },
    pageRangeInput: {
      trackColor: '#CECBD6',
      activeTrackColor: '#34353A',
      thumbColor: '#34353A',
      thumbHoverColor: '#34353ACC',
      thumbFocusBorderColor: '',
    },
  },
  downloadDocumentButton: {
    bgColor: '#FFFFFF',
    color: '#34353A',
    borderColor: 'rgba(50, 95, 255, 1)',
    bgColorHover: '#F1F3F7',
    colorHover: '#34353A',
    borderColorHover: '#CECBD6',
    bgColorDisabled: '#F6F6F6',
    colorDisabled: '#91969B',
    borderColorDisabled: '#F6F6F6',
  },
  button: {
    bgColor: 'rgba(50, 95, 255, 1)',
    padding: '10px 24px',
    borderRadius: '100px',
    width: 'auto',
    border: '1px solid rgba(50, 95, 255, 1)',
    boxShadow: 'none',
    margin: '0',
    color: 'rgba(255, 255, 255, 1)',
    colorHover: 'rgba(255, 255, 255, 1)',
    bgColorHover: 'rgba(91, 127, 255, 1)',
    borderHover: '1px solid rgba(91, 127, 255, 1)',
    bgColorDisabled: 'rgba(172, 176, 181, 1)',
    borderDisabled: '1px solid rgba(172, 176, 181, 1)',
    colorDisabled: 'rgba(246, 246, 246, 1)',
    fontSize: '14px',
    fontWeight: '500',
  },
  buttonSecondary: {
    bgColor: 'transparent',
    padding: '10px 20px',
    borderRadius: '100px',
    width: 'auto',
    border: '2px solid rgba(50, 95, 255, 1)',
    boxShadow: 'none',
    margin: '0',
    color: 'rgba(42, 0, 98, 1)',
    colorHover: 'rgba(42, 0, 98, 1)',
    bgColorHover: 'rgba(241, 243, 247, 1)',
    borderHover: '2px solid rgba(50, 95, 255, 1)',
    bgColorDisabled: 'rgba(246, 246, 246, 1)',
    borderDisabled: '2px solid rgba(246, 246, 246, 1)',
    colorDisabled: 'rgba(127, 133, 139, 1)',
    fontSize: '14px',
    fontWeight: '500',
  },
  buttonDisabled: {
    padding: '10px 24px',
    borderRadius: '100px',
    width: 'auto',
    boxShadow: 'none',
    margin: '0',
    fontSize: '14px',
    fontWeight: '500',
    bgColor: 'rgba(172, 176, 181, 1)',
    border: '1px solid rgba(172, 176, 181, 1)',
    color: 'rgba(246, 246, 246, 1)',
    bgColorHover: 'rgba(172, 176, 181, 1)',
    borderHover: '1px solid rgba(172, 176, 181, 1)',
    colorHover: 'rgba(246, 246, 246, 1)',
    cursor: 'not-allowed',
  },
  header: {
    color: 'rgba(52, 53, 58, 1)',
    fontSize: '1.5rem',
    lineHeight: '2.25rem',
    fontSizeMobile: '1.25rem',
    lineHeightMobile: '1.9375rem',
    margin: '15px 0',
    textAlign: 'center',
    width: '100%',
  },
  selectInput: {
    borderRadius: '4px',
    borderWidth: '1px',
    borderColorFocus: 'rgba(183, 189, 198, 1)',
    backgroundColorSelected: 'rgba(206, 212, 220, 1)',
    backgroundColorFocus: 'rgba(206, 212, 220, 0.75)',
    currentBg: 'rgba(206, 212, 220, 0.50)',
    indicatorColorFocus: 'rgba(48, 52, 56, 1)',
    indicatorColorHover: 'rgba(48, 52, 56, 1)',
    danger: 'rgba(226,64,40,1)',
    dangerLight: 'rgba(226,64,40,0.5)',
  },
  symbol: {
    primary: 'rgba(50, 95, 255, 1)',
    secondary: 'rgba(255, 255, 255, 1)',
    tenary: 'rgba(248, 247, 246, 1)',
  },
  textInput: {
    bgColor: 'white',
    padding: '14px',
    borderRadius: '4px',
    border: '1px solid rgba(183, 189, 198, 1)',
    boxShadow: 'none',
    margin: '0',
    color: 'rgba(43, 37, 58, 1)',
    colorFocus: 'rgba(43, 37, 58, 1)',
    bgColorFocus: 'white',
    borderFocus: '1px solid rgba(43, 37, 58, 1)',
    bgColorDisabled: 'rgba(206, 212, 220, 1)',
    borderDisabled: 'rgba(206, 212, 220, 1)',
    colorDisabled: 'rgba(206, 212, 220, 1)',
    fontSize: '14px',
    fontWeight: '400',
    outline: 'none',
    errorColor: '#d91111',
  },
  brandBar: {
    bgColor: 'white ',
    padding: '30px',
    margin: '0 0 30px 0',
    border: 'none',
    boxShadow: 'none',
    justifyContent: 'normal',
  },
  wrapXs2a: {
    fontFamily: 'Inter',
    fontFamilyHeadline: 'Inter',
    bgColor: 'rgba(248, 247, 246, 1)',
    linkColor: 'rgba(50, 95, 255, 1)',
    linkColorHover: 'rgba(66, 152, 251, 1)',
    checkboxColor: 'rgba(52, 53, 58, 1)',
    checkboxColorActive: 'rgba(50, 95, 255, 1)',
    backButton: {
      borderColor: 'rgba(50, 95, 255, 1)',
      color: 'rgba(52, 53, 58, 1)',
      colorHover: 'rgba(0, 0, 0, 1)',
      disabled: 'rgba(206, 212, 220, 1)',
    },
    input: {
      bgColor: 'white',
      padding: '14px',
      borderRadius: '4px',
      border: '1px solid rgba(183, 189, 198, 1)',
      boxShadow: 'none',
      margin: '0',
      color: 'rgba(43, 37, 58, 1)',
      colorFocus: 'rgba(43, 37, 58, 1)',
      bgColorFocus: 'white',
      borderFocus: '1px solid rgba(43, 37, 58, 1)',
      bgColorDisabled: 'rgba(206, 212, 220, 1)',
      borderDisabled: 'rgba(206, 212, 220, 1)',
      colorDisabled: 'rgba(206, 212, 220, 1)',
      fontSize: '14px',
      fontWeight: '400',
      outline: 'none',
      errorColor: '#d91111',
    },
    button: {
      bgColor: 'rgba(50, 95, 255, 1)',
      padding: '10px 24px',
      paddingMobile: '14px 40px',
      borderRadius: '100px',
      width: 'auto',
      border: '1px solid rgba(50, 95, 255, 1)',
      boxShadow: 'none',
      margin: '0',
      color: 'rgba(255, 255, 255, 1)',
      colorHover: 'rgba(255, 255, 255, 1)',
      bgColorHover: 'rgba(91, 127, 255, 1)',
      borderHover: '1px solid rgba(91, 127, 255, 1)',
      bgColorDisabled: 'rgba(172, 176, 181, 1)',
      borderDisabled: '1px solid rgba(172, 176, 181, 1)',
      colorDisabled: 'rgba(246, 246, 246, 1)',
      fontSize: '14px',
      fontWeight: '500',
    },
  },
  wrapKlarna: {
    bgColor: 'rgba(206, 212, 220, 1)',
  },
  wrapKontomatik: {
    bgColor: '#FFF',
    textColor: 'rgba(52, 53, 58, 1)',
    borderColor: 'rgba(228, 228, 228, 1)',
    headerColor: 'rgba(52, 53, 58, 1)',
    primaryColor: 'rgba(50, 95, 255, 1)',
    primaryReverseColor: '#FFF',
    secondaryColor: '586374',
    mainHoverColor: 'rgba(66, 152, 251, 1)',
    mainHoverReverseColor: '#FFF',
    listHoverColor: '#F5F5F5',
    disabledColor: '#CED4DA',
    errorColor: '#BB0000',
    borderRadius: '2px',
    width: '100%',
    padding: '50px',
    boxShadow: 'none',
    margin: '0 auto',
  },
  progressBar: {
    time: 180,
    secondChance: true,
    showCounter: true,
    height: '17px',
    margin: '40px 0 10px 0',
    padding: '0 20px',
    border: '2px solid rgba(206, 212, 220, 1)',
    borderRadius: '0px',
    background: 'white',
    barFill: 'rgba(50, 95, 255, 1)',
    counterMargin: '20px 0',
    counterPadding: '0',
    counterFontSize: '24px',
    counterColor: 'rgba(52, 53, 58, 1)',
    infoMessageTextAlign: 'center',
    infoMessageFontSize: '12px',
    infoMessageMargin: '6px 0 0 0',
  },
  stepper: {
    borderColor: 'rgba(206, 212, 220, 1)',
    fontSizeTitle: '12px',
    fontSizeDesc: '10px',
  },
  loadingSpinner: {
    primary: 'rgba(50, 95, 255, 1)',
    bgColor: 'rgba(255, 255, 255, 1)',
  },
  tabSwitcher: {
    borderBottom: '2px solid #dbdbdb',
    buttonColor: '#9b9b9b',
    buttonBorderBottom: '4px solid rgba(50, 95, 255, 1)',
    buttonColorActive: '#000',
  },
  errorPage: {
    title: {
      color: 'rgba(52, 53, 58, 1)',
    },
    subtitle: {
      color: '#98959f',
    },
    svg: {
      fill1: 'none',
      fill2: '#ffffff',
      fill3: '#000',
      fill4: 'rgba(50, 95, 255, 1)',
    },
  },
  popup: {
    clickOutsideEnabled: true,
  },
  videoIdCallToActionButton: {
    bgColor: 'rgba(50, 95, 255, 1)',
    padding: '10px 24px',
    borderRadius: '100px',
    width: '150px',
    border: '1px solid rgba(50, 95, 255, 1)',
    boxShadow: 'none',
    margin: '32px 0 0 0',
    color: 'rgba(255, 255, 255, 1)',
    colorHover: 'rgba(255, 255, 255, 1)',
    bgColorHover: 'rgba(91, 127, 255, 1)',
    borderHover: '1px solid rgba(91, 127, 255, 1)',
    bgColorDisabled: 'rgba(172, 176, 181, 1)',
    borderDisabled: '1px solid rgba(172, 176, 181, 1)',
    colorDisabled: 'rgba(246, 246, 246, 1)',
    fontSize: '14px',
    fontWeight: '500',
    textDecoration: 'none',
  },
  videoIdPhoneChangeButton: {
    color: 'rgba(50, 95, 255, 1)',
  },
}
